import { v4 as uuidv4 } from 'uuid';

const softwareData = () => {

    return [
        {
            id: uuidv4(),
            image: "https://images-na.ssl-images-amazon.com/images/I/51uc73ga9QL.jpg",
            name: "Norton Antivirus Plus",
            price: 72990,
        },
        {
            id: uuidv4(),
            image: "https://images-na.ssl-images-amazon.com/images/I/61oh9Mc4UIL._SL1000_.jpg",
            name: "K7 Antivirus Premium",
            price: 15495,
        },
        {
            id: uuidv4(),
            image: "https://images-na.ssl-images-amazon.com/images/I/41uV4b7TexL.jpg",
            name: "Microsoft Windows 10",
            price: 3200,
        },
        {
            id: uuidv4(),
            image: "https://images-na.ssl-images-amazon.com/images/I/61RGkUyHaIL._SX679_.jpg",
            name: "Microsoft Office",
            price: 15495,
        },
        {
            id: uuidv4(),
            image: "https://images-na.ssl-images-amazon.com/images/I/41uV4b7TexL.jpg",
            name: "Microsoft Windows 10",
            price: 3200,
        },
        {
            id: uuidv4(),
            image: "https://images-na.ssl-images-amazon.com/images/I/51uc73ga9QL.jpg",
            name: "Norton Antivirus Plus",
            price: 72990,
        },
        {
            id: uuidv4(),
            image: "https://images-na.ssl-images-amazon.com/images/I/41uV4b7TexL.jpg",
            name: "Microsoft Windows 10",
            price: 3200,
        },
        {
            id: uuidv4(),
            image: "https://images-na.ssl-images-amazon.com/images/I/51uc73ga9QL.jpg",
            name: "Norton Antivirus Plus",
            price: 72990,
        },
    ]
}

export default softwareData;